import { render, staticRenderFns } from "./settings-account-alerts.vue?vue&type=template&id=ac5b3c4a&scoped=true&"
import script from "./settings-account-alerts.vue?vue&type=script&lang=js&"
export * from "./settings-account-alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5b3c4a",
  null
  
)

export default component.exports